import { Component, Input, OnInit } from "@angular/core";
import { TrailerService } from "@app/trailer/shared/trailer.service";
import { FileUploadService } from "@app/shared/services/files/fileUpload.service";
import { LazyLoadEvent } from "primeng/api";

@Component({
  selector: "app-trailer-trip-documents",
  templateUrl: "./trailer-trip-documents.component.html",
  styleUrls: ["./trailer-trip-documents.component.css"],
})
export class TrailerTripDocumentsComponent implements OnInit {
  @Input() trailerId: string;

  tripDocuments: any[] = [];
  cols: any[] = [];
  loading: boolean = false;
  totalRecords: number = 0;
  rows: number = 20;

  constructor(
    private trailerService: TrailerService,
    private fileUploadService: FileUploadService
  ) {}

  ngOnInit() {
    this.initializeColumns();
  }

  initializeColumns() {
    this.cols = [
      { field: "tripNo", header: "TRIP NO", width: 120 },
      { field: "startDate", header: "TRIP START DATE", width: 150 },
      { field: "endDate", header: "TRIP END DATE", width: 150 },
      { field: "productName", header: "PRODUCT", width: 150 },
      { field: "fileName", header: "FILENAME", width: 250 },
      { field: "fileUploadDate", header: "FILE UPLOAD DATE", width: 150 },
    ];
  }

  onLazyLoad(event: LazyLoadEvent) {
    this.loadTripDocuments(
      event.first || 0,
      event.rows || this.rows,
      event.sortField as string,
      event.sortOrder
    );
  }

  loadTripDocuments(
    offset: number = 0,
    limit: number = this.rows,
    sortField?: string,
    sortOrder?: number
  ) {
    if (!this.trailerId) {
      return;
    }

    this.loading = true;
    this.trailerService
      .getTripDocuments(this.trailerId, limit, offset, sortField, sortOrder)
      .subscribe({
        next: (response: any) => {
          this.tripDocuments = response.documents.map((doc: any) => ({
            ...doc,
            startDate: doc.startDate ? new Date(doc.startDate) : null,
            endDate: doc.endDate ? new Date(doc.endDate) : null,
            fileUploadDate: doc.fileUploadDate ? new Date(doc.fileUploadDate) : null,
          }));
          this.totalRecords = response.totalRecords;
          this.loading = false;
        },
        error: (error) => {
          console.error("Error loading trip documents:", error);
          this.loading = false;
        },
      });
  }

  downloadFile(document: any) {
    const fileName = document.filePath || document.fileName;
    if (!fileName) {
      return;
    }

    this.fileUploadService.getPictureUrl(fileName, "trip").subscribe({
      next: (response: any) => {
        const url = response.url;

        // For other file types, try to open directly
        window.open(url, "_blank");
      },
      error: (error) => {
        console.error("Error downloading file:", error);
      },
    });
  }
}
